import { Link } from 'react-router-dom';
import { tx } from '../i18n';

/** Catch-all route. */
export default function NotFoundPage() {
  return (
    <div className="page page--narrow stack" style={{ textAlign: 'center' }}>
      <p className="label">404</p>
      <h1 className="verdict__title">{tx('That page does not exist', 'Bu sayfa yok',
    'Ta strona nie istnieje',
    'Esta página não existe',
    'Esta página no existe')}</h1>
      <p className="muted">{tx('Check the link, or start again with a postcode.', 'Bağlantıyı kontrol edin ya da bir posta koduyla yeniden başlayın.',
    'Sprawdź link albo zacznij od nowa od kodu pocztowego.',
    'Verifique o link, ou recomece com um código postal.',
    'Comprueba el enlace, o empieza de nuevo con un código postal.')}</p>
      <Link to="/" className="button" style={{ alignSelf: 'center' }}>
        {tx('Vet a property', 'Bir konutu inceleyin',
    'Sprawdź mieszkanie',
    'Avaliar um imóvel',
    'Evaluar una vivienda')}
      </Link>
    </div>
  );
}
